
import {createReducer, lazySingleton} from "../../../_common/common";
import {CLEAR_NOTIFICATION, NTYPE_DANGER, NTYPE_INFO, SET_NOTIFICATION, SET_STATUS_MESSAGES} from "../actions/constants";


import {t} from '../../../_i18n';
// import StudentAccountService from "../../../_services/student-account-service";

const initialState : any[] = [];
//const notifType = {1: NTYPE_INFO,4: NTYPE_DANGER}; // 1:pendiente 4:revisar

// const svcStudent = lazySingleton(()=>new StudentAccountService());

const reducer = createReducer(initialState, {

    [SET_STATUS_MESSAGES]: (state, status)=>{

        const messages = status.notifications ? status.notifications.map((n:any)=>({id: null, type: NTYPE_INFO, ...n})) : [];

        // eliminamos todas las que tienen id null
        state = [...state.filter((n:any)=>n.id !== null), ...messages];
        return state;
    },

    [SET_NOTIFICATION]: (state, not)=>{
        not.id = state.length+1;
        state.push(not);
    },

    [CLEAR_NOTIFICATION]: (state, not)=>{
        const idx = state.findIndex((n:any) => n.id == not.id);
        if(idx === -1) return;
        state.splice(idx, 1);
    }

});

export default reducer;
